export { default } from './current-bank-view';
export type { SendDocumentsHandler } from './current-bank-view';
